import * as React from "react";
import {cx} from "emotion";

import "./preferences.scss";

import {cs}    from "@Common/react/chain-services";
import {keyed} from "@Common/react/keyed";

export const Preferences = ({steps, setupModal, className}) => cs(

    ["loading", (_, next) => next(steps.some((step) => step.enrollmentEditor?.loading))],
    ({loading}) => (
        <div className={cx("preferences-05r", className)}>
            <div className="header">
                <div {...{
                    className: "title",

                    "xd-qa-type": "label",
                    "xd-qa-name": "Program Setup",
                }}>
                    Program Setup
                </div>

            </div>

            <div className="actions">
                {steps.map(({arLabel, label, icon, enrollmentEditor}, i) => cs(
                    keyed(i),
                    ["invalid", (_, next) => next(
                        !enrollmentEditor?.valid &&
                        !steps.some((step) => step.enrollmentEditor?.loading)
                    )],
                    ({}) => (
                        <div {...{
                            className: cx("item", {
                                invalid: !enrollmentEditor?.valid && !loading,
                            }),
                            onClick: () => setupModal.show({tab: i}),
                            "xd-qa-type": "button",
                            "xd-qa-name": "Wizard Step " + (arLabel ?? label),
                        }}>
                            <div className="thumb">
                                <div className="icon">
                                    <i {...{
                                        className: cx("fa", "fa-" + icon),
                                        "xd-qa-type": "icon",
                                        "xd-qa-name": arLabel ?? label,
                                    }}/>

                                    <div className="status">
                                        {!loading && (
                                            enrollmentEditor?.valid ? (
                                                <i {...{
                                                    className: "fa fa-check-circle",

                                                    "xd-qa-type": "icon",
                                                    "xd-qa-name": "Wizard Step Selected",
                                                }}/>
                                            ) : (
                                                <i {...{
                                                    className: "fa fa-exclamation-circle",

                                                    "xd-qa-type": "icon",
                                                    "xd-qa-name": "Wizard Step Error",
                                                }}/>
                                            )
                                        )}
                                    </div>
                                </div>


                                <div {...{
                                    className: "label",
                                    "xd-qa-type": "label",
                                    "xd-qa-name": "Wizard Step Name",
                                }}>
                                    {arLabel ?? label}
                                </div>
                            </div>


                            {!loading && !enrollmentEditor?.valid && (
                                <div className="attention">

                                    <div className="title">
                                        Attention Required!
                                    </div>
                                    <div {...{
                                        className: "message",
                                        "xd-qa-type": "label",
                                        "xd-qa-name": "Wizard Step Error",
                                    }}>
                                        Update your settings to prevent program interruption.
                                    </div>
                                </div>
                            )}
                        </div>
                    ),
                ))}
            </div>
        </div>
    ),
);
